<template>
	<i
		v-html="svg"
		:alt="alt"
		:title="title"
		@click="$emit('onClick')"
		:style="{ width: radius, height: radius, strokeWidth }"
		:class="rotate"
		class="d-flex align-center justify center"
	/>
</template>

<script setup lang="ts">
	import { computed } from 'vue'

	interface Props {
		icon: string
		alt?: string
		title?: string
		radius?: string
		rotate?: '' | 'right' | 'down' | 'left'
		strokeWidth?: number
	}

	const props = withDefaults(defineProps<Props>(), {
		radius: '16px',
		alt: '',
		title: '',
		rotate: '',
		strokeWidth: 1,
	})
	defineEmits(['onClick'])

	const modules = import.meta.glob('./icons/*.svg', {
		query: '?raw',
		import: 'default',
		eager: true,
	})

	const svg = computed(() => {
		const path = `./icons/${props.icon}.svg`
		if (!(path in modules)) return ''
		const theSvg = modules[path] as string
		theSvg.replace(/stroke-width="[^"]*"/g, `stroke-width="${props.strokeWidth}"`)
		return theSvg
	})
</script>

<style scoped>
	.right {
		transform: rotate(90deg);
	}
	.down {
		transform: rotate(180deg);
	}
	.left {
		transform: rotate(270deg);
	}
</style>
